import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import './Users.css';
import translations from './lang'; // Fordítások importálása

export class Users extends Component {
    constructor(props) {
        super(props);
        this.state = { users: [] };
    }

    refreshList() {
        fetch(`${process.env.REACT_APP_API}/users/`)
        .then(response => response.json())
        .then(data => {
            this.setState({ users: data.data });
        });
    }

    componentDidMount() {
        this.refreshList();
    }

    render() {
        const { users } = this.state;
        const language = localStorage.getItem('language') || 'ro';
        const t = translations[language];

        return (
            <div className="container">
                <h1>{t.users}</h1>
                <Table className="mt-4" striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>{t.first_name}</th>
                            <th>{t.last_name}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(user => (
                            <tr key={user.id}>
                                <td>{user.first_name}</td>
                                <td>{user.last_name}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    }
}
